import { render } from "./ServiceOrderCreate.vue?vue&type=template&id=09f4d7ca&scoped=true"
import script from "./ServiceOrderCreate.vue?vue&type=script&lang=js"
export * from "./ServiceOrderCreate.vue?vue&type=script&lang=js"

import "./ServiceOrderCreate.vue?vue&type=style&index=0&id=09f4d7ca&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f4d7ca"]])

export default __exports__